import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import { Disclosure } from "@headlessui/react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { SvgShapeDropdown } from "@routes/IconeSvg";

import calendar_carrer from "@assets/image/icones/carrer/calendar_carrer.svg";

import { formatTextPeriod } from "@helpers/_functions";

import SalaryForm from "./SalaryForm/index";

/** @type {typeof Tooltip} */
// @ts-ignore
const BlackTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: "200px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "8px 17px"
  }
}))(Tooltip);

/**
 *
 * @param {Object} props
 * @param {Object} props.salary
 * @param {boolean} props.status
 * @param {Object} props.career
 * @param {Object | null} props.employeePoste
 * @param {Object[]} props.careerList
 * @param {boolean} props.readOnly
 * @param {Function} props.onDuplicate
 * @param {any[]} props.otherSalaries
 * @returns
 */
export default function SalaryItem(props) {
  const { salary, status, readOnly, onDuplicate, career, careerList } = props;

  const { t: translate, i18n } = useTranslation([
    "pages.employés.emploi&Salary",
    "message"
  ]);

  const periodText = useMemo(() => {
    return formatTextPeriod({
      dateStart: salary?.salaryBegin,
      endDate: salary?.salaryEnd,
      article1: translate("DU"),
      article2: translate("AU"),
      icon: calendar_carrer,
      status: status,
      language: i18n.language
    });
  }, [
    salary?.salaryBegin,
    salary?.salaryEnd,
    status,
    translate,
    calendar_carrer,
    i18n.language
  ]);

  return (
    <Disclosure key={salary._id}>
      {({ open, close }) => (
        <>
          <Disclosure.Button
            as="tr"
            className="hover:arh-bg-lightGreyColor cursor-pointer"
          >
            <td className="arh-h-12 arh-pl-4 arh-pr-2 arh-align-middle">
              <div className="arh-flex arh-items-center arh-gap-2">
                <div className="arh-border-0 arh-bg-transparent arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor">
                  <div
                    className={`${open
                      ? "arh-w-fit arh-rotate-0 arh-transform"
                      : "arh-w-fit -arh-rotate-90 arh-transform"
                      }`}
                  >
                    {SvgShapeDropdown()}
                  </div>
                </div>

                <BlackTooltip
                  placement="top"
                  title={
                    <p
                      className="arh-m-0 arh-w-full"
                      style={{
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 5,
                        fontSize: "12px"
                      }}
                    >
                      {salary.title}
                    </p>
                  }
                >
                  <p className="arh-mb-0 arh-w-full arh-max-w-[12rem] arh-shrink arh-truncate arh-font-poppins arh-text-fontBodyTable arh-font-medium arh-text-darkGreyColor desktop-middle:arh-w-24">
                    {salary.title}
                  </p>
                </BlackTooltip>
              </div>
            </td>

            <td className="arh-h-12 arh-pr-[2%] arh-align-middle">
              <div className="arh-flex arh-items-center arh-gap-2 arh-text-xs arh-font-medium arh-text-darkGreyColor">
                {periodText}
              </div>
            </td>

            <td className="arh-h-12 arh-align-middle"></td>
            <td className="arh-h-12 arh-align-middle"></td>

            <td className="arh-h-12 arh-py-1 arh-pr-4 arh-align-middle">
              {!readOnly && (
                <button
                  type="button"
                  className="arh-float-right arh-border-0 arh-bg-transparent arh-font-poppins arh-text-[11px] arh-font-medium arh-text-[#5C998D] arh-underline"
                  onClick={(event) => {
                    event.stopPropagation();
                    if (onDuplicate) {
                      onDuplicate(salary);
                    }
                  }}
                >
                  {translate("Dupliquer")}
                </button>
              )}
            </td>
          </Disclosure.Button>

          <Disclosure.Panel
            as="tr"
            className="arh-bg-lightGreyColor"
          >
            <td
              colSpan={5}
              className="arh-p-4"
            >
              <div className="arh-w-full arh-rounded arh-border arh-border-solid arh-border-greyInput arh-bg-white arh-p-4">
                <SalaryForm
                  career={career}
                  readOnly={readOnly}
                  employeePoste={props.employeePoste}
                  careerList={careerList}
                  selectedSalary={salary}
                  isOpen={open}
                  onClose={close}
                  employeeId={career.employeeId}
                  otherSalaries={props.otherSalaries}
                />
              </div>
            </td>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
